module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-535.d82af57.woff2";